import { BASE_URL } from '@/config'
// 地址填充
function fullImgUrl(obj, key = 'listPic', pro = 'attrs') {
if(Array.isArray(obj)){
		return obj.map(item => fullImgUrl(item, key, pro))
	}
	if(!obj) return '';
	let url = typeof obj === 'string' ? obj : (obj[key] || (obj[pro] && obj[pro][key]) || false);
	if(!url) return '';
	if (/(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g.test(url)) {
		return url
	} else {
		return BASE_URL + url
	}
}
// 时间格式转换
function timestampFormat(timestamp, long) {
	timestamp *= 1;
	if(isNaN(timestamp)) return '';
	var curTimestamp = Date.now(); //当前时间戳
	var timestampDiff = parseInt((curTimestamp - timestamp) / 1000); // 参数时间戳与当前时间戳相差秒数
	var curDate = new Date(curTimestamp); // 当前时间日期对象
	var tmDate = new Date(timestamp); // 参数时间戳转换成的日期对象
	var Y = tmDate.getFullYear(),
		m = tmDate.getMonth() + 1,
		d = tmDate.getDate();
	var H = tmDate.getHours(),
		i = tmDate.getMinutes(),
		s = tmDate.getSeconds();
	if (long == 'middle') {
		return zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
	}
	if (long == 'date') {
		return Y + '-' + zeroize(m) + '-' + zeroize(d);
	}
	if (long == 'y.m') {
		return Y + '.' + zeroize(m);
	}
	if (long == 'd') {
		return zeroize(d);
	}
	if (long == 'sort') {
		return zeroize(H) + ':' + zeroize(i);
	}
	if (long === 'long') {
		return Y + '/' + zeroize(m) + '/' + zeroize(d) + ' ' + zeroize(H) + ':' + zeroize(i);
	}
	if (timestampDiff < 60) { // 一分钟以内
		return "刚刚";
	} else if (timestampDiff < 3600) { // 一小时前之内
		return Math.floor(timestampDiff / 60) + "分钟前";
	} else if (curDate.getFullYear() == Y && curDate.getMonth() + 1 == m && curDate.getDate() == d) {
		return '今天 ' + zeroize(H) + ':' + zeroize(i);
	} else {
		var newDate = new Date((curTimestamp - 86400) * 1000); // 参数中的时间戳加一天转换成的日期对象
		if (newDate.getFullYear() == Y && newDate.getMonth() + 1 == m && newDate.getDate() == d) {
			return '昨天 ' + zeroize(H) + ':' + zeroize(i);
		} else if (curDate.getFullYear() == Y) {
			return zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i);
		} else {
			return Y + '年' + zeroize(m) + '月' + zeroize(d) + '日';
		}
	}
}

// 保留固定小数
function reservedDecimal(num, fixed = 1) {
	if (!num) return Number(0).toFixed(fixed);
	num = String(num);
	let splitNum = num.split('.')
	let firstNum = splitNum[0];
	let lastNum = splitNum[1] ? String(splitNum[1]) : (new Array(fixed + 1)).join('0');
	let toFixedNum = (lastNum && lastNum.length) || 0;
	toFixedNum = toFixedNum > fixed ? fixed : toFixedNum;
	//toFixed会进行四舍五入 所以我们用裁剪
	// return .toFixed(toFixedNum);
	return firstNum + (toFixedNum > 0 ? '.' : '') + lastNum.substr(0, toFixedNum)
}
// 转换单位
function unitConvert(num) {
	if(!num && num !== 0) return num || 0;
    var moneyUnits = ["", "万", "亿", "万亿"]
    var dividend = 10000;
    var curentNum = num || 0;
    //转换数字
    var curentUnit = moneyUnits[0];
    //转换单位
    for (var i = 0; i <4; i++) {
        curentUnit = moneyUnits[i]
        if(strNumSize(curentNum)<5){
            break;
        }
        curentNum = curentNum / dividend
    }
	return reservedDecimal(curentNum, 1) * 1 + curentUnit;
}

function strNumSize(tempNum){
    var stringNum = tempNum.toString()
    var index = stringNum.indexOf(".")
    var newNum = stringNum;
    if(index!=-1){
        newNum = stringNum.substring(0,index)
    }
    return newNum.length
}

function zeroize(num) {
	return num > 9 ? num : ('0' + num);
}

export default {
	unit: unitConvert,
	time: timestampFormat,
	imgUrl: fullImgUrl,
	price: reservedDecimal
}
